// src/api.js
import axios from "axios";
import jwt_decode from "jwt-decode";
import store from "../store";
import {logout} from "../redux/actions/authSlice.js"; // replace with your logout action

const api = axios.create();

api.interceptors.request.use(
  (config) => {
    const state = store.getState();
    const token = state.auth.token; // Replace 'auth' with the name of the slice containing the token

    if (token) {
      const decodedToken = jwt_decode(token);
      const currentTime = Date.now() / 1000; // to get in milliseconds
      if (decodedToken.exp < currentTime) {
        store.dispatch(logout()); // dispatching logout action
      } else {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // debugger;

    // If the request returns a 401, it means the token is invalid
    if (error.response && error.response.status === 401) {
      store.dispatch(logout()); // Dispatch your logout action
    }
    return Promise.reject(error);
  }
);

export default api;
